import ChipInput from 'material-ui-chip-input';
import PropTypes from 'prop-types';
import React from 'react';

const RFMultiInput = ({ label, input, users}) => {
    return <ChipInput onChange={input.onChange} defaultValue={users} fullWidth label={label} placeholder="Type and press enter to add" />;
};
RFMultiInput.propTypes = {
    label: PropTypes.string,
    input: PropTypes.object,
};

export default RFMultiInput;
